// extract the variables from the schema
export const getVariableMap = (spec) => {
    const variableMap = {};
    const { headline, sections } = spec;
    const allPhrases = [];
    if (headline === null || headline === void 0 ? void 0 : headline.phrases) {
        allPhrases.push(...headline.phrases);
    }
    const addPhrases = (paragraph) => {
        var _a;
        switch (paragraph === null || paragraph === void 0 ? void 0 : paragraph.type) {
            case 'heading1':
            case 'heading2':
            case 'heading3':
            case 'heading4':
            case 'heading5':
            case 'heading6':
            case 'normal': {
                const phrases = paragraph.phrases;
                if (phrases === null || phrases === void 0 ? void 0 : phrases.length) {
                    allPhrases.push(...phrases);
                }
                break;
            }
            case 'bullets':
                (_a = paragraph.bullets) === null || _a === void 0 ? void 0 : _a.forEach((bullet) => {
                    const { subBullet, phrases } = bullet;
                    if (phrases === null || phrases === void 0 ? void 0 : phrases.length) {
                        allPhrases.push(...phrases);
                    }
                    if (subBullet) {
                        addPhrases(subBullet);
                    }
                });
                break;
            default:
                break;
        }
    };
    sections === null || sections === void 0 ? void 0 : sections.forEach((section) => {
        var _a;
        (_a = section.paragraphs) === null || _a === void 0 ? void 0 : _a.forEach((paragraph) => {
            addPhrases(paragraph);
        });
    });
    let variableIndex = 0;
    allPhrases.forEach((phrase) => {
        var _a;
        if (phrase.type === 'entity') {
            const variableKey = ((_a = phrase.metadata) === null || _a === void 0 ? void 0 : _a.sourceId) || `variable_${(variableIndex += 1)}`;
            variableMap[variableKey] = phrase;
        }
    });
    return variableMap;
};
//# sourceMappingURL=data:application/json;base64,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